var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4367 5.3483C17.2609 5.27402 17.0663 5.40309 17.0663 5.59394V13.446H14.9329V9.92391L4.1034 5.3483C3.92759 5.27402 3.73294 5.40309 3.73294 5.59395V26.2498C3.73294 26.3971 3.85233 26.5165 3.99961 26.5165H27.9996C28.1469 26.5165 28.2663 26.3971 28.2663 26.2498V10.1007C28.2663 9.99356 28.2021 9.8968 28.1034 9.85509L17.4367 5.3483ZM14.9329 7.60797L4.93368 3.38318C3.35141 2.71465 1.59961 3.87624 1.59961 5.59395V26.2498C1.59961 27.5753 2.67413 28.6498 3.99961 28.6498H27.9996C29.3251 28.6498 30.3996 27.5753 30.3996 26.2498V10.1007C30.3996 9.13619 29.8222 8.26536 28.9337 7.88996L18.267 3.38318C16.6847 2.71465 14.9329 3.87624 14.9329 5.59394V7.60797ZM9.33294 22.6498H7.11072V20.5165H9.33294V22.6498ZM13.7774 22.6498H11.5552V20.5165H13.7774V22.6498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.a641ac1d7d4890509a2a36807adb06fa.svg";
export { ForwardRef as ReactComponent };